import { memo } from "react";
import Page from "components/page/Page";
import { Helmet } from "react-helmet";
import GoogleAd from "components/googleAd/GoogleAd";
import Card from "components/card/Card";
import { PageCollapseWidth } from "../../constants";
import { useAppDispatch, useAppSelector } from "hooks";
import encodeSlice from "reducers/encodeSlice";
import { RootState } from "store";
import {
  busySelector,
  errorSelector,
  outputSelector,
} from "selectors/encodeSelectors";
import EncodeOutput from "components/encodeOutput/EncodeOuput";
import EncodeInput from "components/encodeInput/EncodeInput";
import GuidGenerateInfo from "components/guidGenerateInfo/GuidGenerateInfo";

const GuidGeneratePage = () => {
  const dispatch = useAppDispatch();

  const handleSubmit = (input: any) => {
    dispatch(encodeSlice.actions.guidGenerate({ input }));
  };

  const busy = useAppSelector((state: RootState) => busySelector(state));

  const error = useAppSelector((state: RootState) => errorSelector(state));

  const output = useAppSelector((state: RootState) => outputSelector(state));

  return (
    <>
      <Helmet>
        <title>
          GUID Generator Online – Create UUIDs Instantly | ToolWeaver
        </title>
        <meta
          name="description"
          content="Generate GUIDs and UUIDs instantly online. Create unique identifiers securely with this free GUID generator."
        />
        <link rel="canonical" href="https://toolweaver.com/guidgenerate" />
      </Helmet>
      <Page>
        <GoogleAd hideOnWidth={PageCollapseWidth} />
        <Card collapseOnWidth={PageCollapseWidth} title="GUID Generator">
          {!output && (
            <EncodeInput
              showInput={false}
              onSubmit={handleSubmit}
              busy={busy}
              error={error}
              buttonText="Generate"
              header="Click 'Generate' to generate a GUID"
            />
          )}
          {output && (
            <EncodeOutput output={output} header="Your GUID is below." />
          )}
        </Card>

        <GoogleAd showOnWidth={PageCollapseWidth} type="medium-rectangle" />
        <GoogleAd hideOnWidth={PageCollapseWidth} />
        <Card
          isLast={true}
          collapseOnWidth={PageCollapseWidth}
          title="How does GUID generation work?"
          headingLevel={2}
        >
          <GuidGenerateInfo />
        </Card>
      </Page>
    </>
  );
};

export default memo(GuidGeneratePage);
